import { Box, Button, Checkbox, FormControl, FormLabel, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import React, { useEffect } from 'react'


const CMColumnBasedFilter = ({ columns, handleColumnFilters, alreadyCheckedColumns, initialColumns, extandableColumns,setIsOpen, handleClose, secondPartInitialColumns = ["Actions"] }) => {

    const [selectedColumns, setSelectedColumns] = React.useState([]);
    useEffect(() => {
        if(alreadyCheckedColumns.length) {
            const expandableColumnNames = alreadyCheckedColumns.filter((checkedColumn) => !initialColumns.some((column) => column.name === checkedColumn.name))
        setSelectedColumns(expandableColumnNames.map((column) => column.name ))
        }
    }, [])

    const handleSelect = (event) => {
        const selected = event.target.value;
        setSelectedColumns(selected);
    };

    const handleSubmit = () => {
        const consistentColumns = initialColumns.reduce((consistentColumns, column) => {
            if (secondPartInitialColumns.includes(column.name)) {
                consistentColumns.secondHalf.push(column)
            } else {
                consistentColumns.firstHalf.push(column)
            }
            return consistentColumns
        }, { firstHalf: [], secondHalf: [] })
        const newFilters = extandableColumns.filter((column) => selectedColumns.includes(column.name))
        handleColumnFilters([...consistentColumns.firstHalf, ...newFilters, ...consistentColumns.secondHalf]);
        setIsOpen(false)
    };

    const handleNoFilter = () => {
        setSelectedColumns([]);
    }

    const handleSelectAllFilter = () => {
        setSelectedColumns(columns)
    }

    return (
        <div style={{ width: "90%" }}>
            <Grid container spacing={2}>
                <Grid item xs={7} style={{ textAlign: "end" }}>
                    <h3>Column Filters</h3>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={2} style={{ textAlign: "end" }}>
                    <Button variant='outlined' onClick={handleNoFilter}>No Filters</Button>
                </Grid>
                <Grid item xs={8} style={{ textAlign: "center" }}>
                    <FormControl style={{ m: 1, minWidth: 300 }}>
                        <Select multiple variant='outlined'
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left'
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left'
                                },
                                style: { maxHeight: 400 }
                              }}
                            value={selectedColumns}
                            onChange={handleSelect}
                            renderValue={(selected) => `${selected.length} column${selected.length > 1 ? "s": "" } selected`}>
                            {columns.map((columnName) => (
                                <MenuItem key={columnName} value={columnName}>
                                    <Checkbox checked={selectedColumns.includes(columnName)} />
                                    {columnName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "end" }}>
                    <Button variant='outlined' onClick={handleSelectAllFilter}>Select All</Button>
                </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: 'center', marginTop: "20px" }}>
                <Button variant="contained" onClick={handleSubmit} >
                    Submit
                </Button>
                <Button variant="contained" onClick={handleClose} style={{marginLeft: '1rem'}}>
                    Close
                </Button>
            </Box>
        </div>
    )
}

export default CMColumnBasedFilter